var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/AWS/Servers@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arch-Category_Customer-Enablement_64"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#658BD3",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SERVER",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 9.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8750001,0 L2.12500044,0 C0.951269807,0 5.06639646e-07,0.959263188 5.06639646e-07,2.14285714 L5.06639646e-07,4.28571429 C5.06639646e-07,5.46930824 0.951269807,6.42857143 2.12500044,6.42857143 L14.8750001,6.42857143 C16.0487307,6.42857143 17.0000005,5.46930824 17.0000005,4.28571429 L17.0000005,2.14285714 C17.0000005,0.959263188 16.0470699,0 14.8750001,0 Z M15.40625,4.28571429 C15.40625,4.58109447 15.1679177,4.82142857 14.8750001,4.82142857 L2.12500044,4.82142857 C1.83214865,4.82142857 1.59374995,4.58035673 1.59374995,4.28571429 L1.59374995,2.14285714 C1.59374995,1.84747798 1.83208228,1.60714286 2.12500044,1.60714286 L14.8750001,1.60714286 C15.1679177,1.60714286 15.40625,1.84747798 15.40625,2.14285714 L15.40625,4.28571429 Z M14.8750001,8.57142857 L2.12500044,8.57142857 C0.951269807,8.57142857 0,9.53069176 0,10.7142857 L0,12.8571429 C0,14.0407368 0.9512693,15 2.12499994,15 L14.8749996,15 C16.0487302,15 17,14.0407368 17,12.8571429 L17,10.7142857 C17,9.53236648 16.0470694,8.57142857 14.8749996,8.57142857 L14.8750001,8.57142857 Z M15.4062495,12.8571429 C15.4062495,13.152522 15.1679172,13.3928571 14.8749996,13.3928571 L2.12499994,13.3928571 C1.83208177,13.3928571 1.59374945,13.152522 1.59374945,12.8571429 L1.59374945,10.7142857 C1.59374945,10.4189066 1.83208177,10.1785714 2.12499994,10.1785714 L14.8749996,10.1785714 C15.1679172,10.1785714 15.4062495,10.4189066 15.4062495,10.7142857 L15.4062495,12.8571429 Z M11.6874997,2.41071429 C11.2475583,2.41071429 10.8906247,2.77031217 10.8906247,3.21428571 C10.8906247,3.65792411 11.2475583,4.01785714 11.6874997,4.01785714 C12.127441,4.01785714 12.4843746,3.65959781 12.4843746,3.21428571 C12.4843746,2.76897362 12.1291008,2.41071429 11.6874997,2.41071429 Z M13.8124996,2.41071429 C13.3725582,2.41071429 13.0156246,2.77031217 13.0156246,3.21428571 C13.0156246,3.65792411 13.3725582,4.01785714 13.8124996,4.01785714 C14.252441,4.01785714 14.6093746,3.65959781 14.6093746,3.21428571 C14.6093746,2.76897362 14.2541007,2.41071429 13.8124996,2.41071429 Z M11.6874997,10.9821429 C11.2475583,10.9821429 10.8906247,11.3417407 10.8906247,11.7857143 C10.8906247,12.2293527 11.2475583,12.5892857 11.6874997,12.5892857 C12.127441,12.5892857 12.4843746,12.2293527 12.4843746,11.7857143 C12.4843746,11.3404022 12.1291008,10.9821429 11.6874997,10.9821429 Z M13.8124996,10.9821429 C13.3725582,10.9821429 13.0156246,11.3417407 13.0156246,11.7857143 C13.0156246,12.2293527 13.3725582,12.5892857 13.8124996,12.5892857 C14.252441,12.5892857 14.6093746,12.2293527 14.6093746,11.7857143 C14.6093746,11.3404022 14.2541007,10.9821429 13.8124996,10.9821429 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.0e80af7c3ddcf9b7958a028761fb6028.svg";
export { ForwardRef as ReactComponent };